import List, { ListOptions, ListComponent } from './Classes/List';

export default (options: ListOptions, filterData = {}):ListComponent => {
  return List(options, filterData)
};
